export const ENTITY_TYPES = {
  case: { label: 'Case', badge: 'entity-badge-case', path: (id) => `/cases/${id}` },
  indicator: { label: 'Indicator', badge: 'entity-badge-indicator', path: (id) => `/indicators/${id}` },
  observable: { label: 'Observable', badge: 'entity-badge-observable', path: (id) => `/indicators/${id}` },
  search: { label: 'Search', badge: 'entity-badge-search', path: (id) => `/intelligence/search/${id}` },
  actor: { label: 'Actor', badge: 'entity-badge-actor', path: (id) => `/actors/${id}` },
  organization: { label: 'Organization', badge: 'entity-badge-organization', path: (id) => `/organizations/${id}` },
  persona: { label: 'Persona', badge: 'entity-badge-persona', path: () => '/personas' },
  evidence: { label: 'Evidence', badge: 'entity-badge-evidence', path: () => '/evidence' },
};

export function entityPath(type, id) {
  const config = ENTITY_TYPES[type];
  if (!config) return '/';
  const path = config.path(id);
  return path || '/';
}

export function entityLabel(type) {
  return ENTITY_TYPES[type]?.label || type;
}

export function relationLabel(relation) {
  return (relation || 'related').replace(/_/g, ' ');
}
